export const environment = {
	production: false,
	basePolicyUrl: "https://dev-wwwpolicyeventinfo3.floridafamily.com",
	bypassPolicyUrl: "https://dev-wwwpolicyeventinfo3-bypass.floridafamily.com",
	baseUrl: "https://dev-www.floridafamily.com",
	policyHolderUrl: "https://dev-wwwpolicyholder3.floridafamily.com",
	agentUrl: "https://dev-wwwagent3.floridafamily.com/",
	cyberSourceURL: "https://testsecureacceptance.cybersource.com/silent/pay"
  };